import { todayIST } from "./format";

const ymd = (d) => d.toISOString().slice(0, 10);
const addDays = (s, n) => {
  const d = new Date(`${s}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return ymd(d);
};
const monthRange = (y, m) => ({ from: `${y}-${String(m).padStart(2, "0")}-01`, to: ymd(new Date(Date.UTC(y, m, 0))) });

export const PRESETS = [
  { key: "this_month", label: "This Month" },
  { key: "last_month", label: "Last Month" },
  { key: "last_7", label: "Last 7 Days" },
  { key: "last_30", label: "Last 30 Days" },
  { key: "all", label: "All Time" },
  { key: "custom", label: "Custom range" },
];

export function presetRange(key, custom) {
  const t = todayIST();
  const [y, m] = t.split("-").map(Number);
  switch (key) {
    case "this_month": return monthRange(y, m);
    case "last_month": return m === 1 ? monthRange(y - 1, 12) : monthRange(y, m - 1);
    case "last_7": return { from: addDays(t, -6), to: t };
    case "last_30": return { from: addDays(t, -29), to: t };
    case "custom": return custom;
    default: return { from: "", to: "" };
  }
}
